<template>
<slot />
</template>
